module.exports = __webpack_public_path__ + "img/48.cb57727d.jpg";